export default [{
  name: 'pagolVeiculos',
  namespaced: true,
  state: {
    model: {
      PropostaDadosVeiculo: {},
      selecionado: {},
      Pessoa: {
        PF: {},
        PJ: {},
        PessoaDadosContato: {},
        PessoaQualificacao: {},
        PessoaEndereco: {}
      }
    },
  },
  mutations: {
    model (state, obj) {
      state.model = obj
    },
    dadosIniciais (state, obj) {
      state.dadosIniciais = obj
    }
  },
  getters: {
    model (state) {
      return state.model
    },
    dadosIniciais (state) {
      return state.dadosIniciais
    }
  },
  actions: {
    clearModel ({ commit }) {
      const data = {
        PropostaDadosVeiculo: {},
        selecionado: {},
        Pessoa: {
          PF: {},
          PJ: {},
          PessoaDadosContato: {},
          PessoaQualificacao: {},
          PessoaEndereco: {}
        }
      }
      commit('model', data)
    }
  },
}]
